module.exports = __webpack_public_path__ + "img/Sprogreformation_Wergeland_som_dikter.89bb2ffe.jpg";